// Common

export const MESSAGE_SEEN = 'MessageSeen'
export const KICKOUT = 'Kickout'
export const LOG_OFF = 'LogOff'
export const NEW_DOCUMENT = 'NewDocument'
export const REFRESH_CHAT_CONTACT_STATE = 'RefreshChatContactsState'
export const NEW_APPOINTMENT = 'NewAppointment'
export const INMEDIATA_ERROR = 'InmediataError'
export const VIDEO_CANCELED = 'VideoCanceled'
export const ACCEPT = 'Accept'
export const CHAT_CANCELED = 'ChatCanceled'
export const APPOINTMENT_CANCELED = 'AppointmentCanceled'
export const NEW_CHAT_MESSAGE = 'NewChatMessage'
export const EDIT_CHAT_MESSAGE = 'EditChatMessage'
export const DELETE_CHAT_MESSAGE = 'DeleteChatMessage'


// Patient

export const REJECTED = 'Rejected'
export const NEW_CONSOLIDATION = 'NewConsolidation'
export const INMEDIATA_NOTIFICATION = 'InmediataNotification'
export const WRITTEN_NOTIFICATION = 'WrittenNotification'
export const CHAT_NOTIFICATION = 'ChatNotification'
export const CHAT_CREATED_BY_DOCTOR = 'ChatCreatedByDoctor'
export const CALL_NOTIFICATION = 'CallNotification'
export const ACTIVE_CHAT_ALERT = 'ActiveChatAlert'
export const ACTIVE_WRITTEN_ALERT = 'ActiveWrittenAlert'
export const ACTIVE_CALL_ALERT = 'ActivecCallAlert'
export const CHAT_CONSOLIDATED = 'ChatConsolidated'
export const REFRESH_TAB_COMPANIES = 'RefreshTabCompanies'
export const APPOINTMENT_ASSIGNED_CENTER = 'AppointmentAssignedCenter'

// Professional
export const NEW_INSTANT_APPOINTMENT = 'NewInstantAppointment'
export const VIDEO_NOTIFICATION = 'VideoNotification'
export const RESET_VIDEO_NOTIFICATION = 'ResetVideoNotification'
export const ENABLE_QUEUE_BUTTON = 'EnableQueueButton'
export const DISABLE_QUEUE_BUTTON = 'DisableQueueButton'
export const ENABLE_WRITTEN_BUTTON = 'EnableWrittenButton'
export const DISABLE_WRITTEN_BUTTON = 'DisableWrittenButton'
export const ALERT_WAITING = 'AlertWaiting'
export const ALERT_IMMEDIATE = 'AlertImmediate'
export const APPOINTMENT_RECEIVED = 'AppointmentReceived'
export const CHAT_RECEIVED = 'ChatReceived'
export const INTERCONSULTATION_ACTION = 'InterconsultationAction'
export const CHAT_REASSIGNED = 'ChatReassigned'

// Center


export const NOTIFICATION_TYPE_COMMANDS = [
	NEW_CONSOLIDATION,
	INMEDIATA_NOTIFICATION,
	WRITTEN_NOTIFICATION,
	CHAT_NOTIFICATION,
	CALL_NOTIFICATION,
	NEW_CHAT_MESSAGE,
	EDIT_CHAT_MESSAGE,
	DELETE_CHAT_MESSAGE,
	CHAT_CONSOLIDATED,
	CHAT_CREATED_BY_DOCTOR,
	ACTIVE_CHAT_ALERT,
	ACTIVE_WRITTEN_ALERT,
	ACTIVE_CALL_ALERT,
	NEW_APPOINTMENT,
	NEW_DOCUMENT,
	CHAT_CANCELED,
	VIDEO_CANCELED
]


// WEBPACK FOOTER //
// ./src/constants/signalRCommands.js